import { render, staticRenderFns } from "./AddCategroy.vue?vue&type=template&id=40ea2144&scoped=true&"
import script from "./AddCategroy.vue?vue&type=script&lang=ts&"
export * from "./AddCategroy.vue?vue&type=script&lang=ts&"
import style0 from "./AddCategroy.vue?vue&type=style&index=0&id=40ea2144&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ea2144",
  null
  
)

export default component.exports